import React, { useEffect, useState } from 'react';
import { Button, Col, Row, message } from 'antd';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import ExerciseCategory from '../atoms/exercise_category';
import ExerciseName from '../atoms/exercise_name';
import { restApi } from '../../../apis';

// import icoGoBack from '../../../assets/images/ico_goback.png';
//----------------------------------------------------------------------------------------------------
const CreateNewExercise = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const location = useLocation();
  const { id: centerId } = useParams();
  const { setGModal, loading, setLoading } = props;

  const [state, setState] = useState({
    type: 'large', // large > mid > small > exercise
    nextType: 'mid',
    rootId: -1,
    large: [],
    largeId: '',
    largeName: '',
    mid: [],
    midId: '',
    midName: '',
    small: [],
    smallId: '',
    smallName: '',
    reload: new Date(),
  });

  useEffect(() => {
    setState((prev) => {
      return {
        ...prev,
        rootId: 0,
      };
    });
  }, []);

  //----------------------------------------------------------------------------------------------------
  const largeInitData = () => {
    // 데이터 가져오기
    setLoading(true);

    // 대분류 정보 가져오기
    (async () => {
      const response = await restApi.get(`/category`);
      const payload = response?.data?.payload;
      if (payload) {
        setState((prev) => {
          return {
            ...prev,
            large: payload?.categories || [],
            mid: [],
            midId: '',
            small: [],
            smallId: '',
          };
        });
      }
      setLoading(false);
    })();

    setTimeout(() => {
      if (loading) {
        setLoading(false);
      }
    }, 5000);
  };

  const midInitData = () => {
    // 데이터 가져오기
    setLoading(true);

    (async () => {
      const response = await restApi.get(`/category/${state?.largeId}`);
      const payload = response?.data?.payload;
      if (payload) {
        setState((prev) => {
          return {
            ...prev,
            mid: payload?.categories?.subCategory || [],
            midId: '',
            small: [],
            smallId: '',
          };
        });
      }
      setLoading(false);
    })();

    setTimeout(() => {
      if (loading) {
        setLoading(false);
      }
    }, 5000);
  };

  //----------------------------------------------------------------------------------------------------
  return (
    <div style={{ ...styles.constainer }}>
      {contextHolder}
      <div style={{ ...styles.header }}>
        <Button
          style={{
            display: 'flex',
            width: '2.4rem',
            height: '2.4rem',
            alignItems: 'center',
          }}
          type="text"
          shape="default"
          size="middle"
          icon={
            <img
              width={24}
              height={24}
              src={require('../../../assets/images/ico_goback.png')}
            />
          }
          onClick={(e) => {
            // goback
            // navigate(-1);
            // return;
            navigate('/exercises', {
              replace: false,
              state: {
                ...location.state,
                isBack: true,
              },
            });
          }}
        />
        <div
          style={{ marginLeft: '2rem' }}
        >{`운동 카테고리 및 운동 영상 추가하기`}</div>
      </div>
      <div style={{ marginTop: 26 }} />
      {/* ---------------------------------------------------------------------------------------------------- */}
      <Row
        // gutter={[26, 16]}
        justify="space-between"
        gutter={26}
      >
        <Col span={5}>
          <ExerciseCategory
            {...props}
            key={'large'}
            title={'대분류'}
            parentId={state.rootId}
            categories={state.large}
            selectedId={state.largeId}
            initData={() => {
              largeInitData();
            }}
            addItem={async (args) => {
              // 추가
              const { value, setChildState } = args;

              if (value.length) {
                await restApi.post(`/admin/category`, {
                  name: value,
                });
              }

              setChildState((prev) => {
                return {
                  ...prev,
                  loading: false,
                  reload: new Date(),
                };
              });
            }}
            updateItem={async (args) => {
              const { id, name } = args;
              if (id?.length && name.length) {
                await restApi.patch(`/admin/category/${id}`, {
                  name,
                });
              }
            }}
            deleteItem={async (args) => {
              const { id } = args;
              if (id?.length) {
                await restApi.delete(`/admin/category/${id}`);
                largeInitData();
              }
            }}
            OnCellClick={(args) => {
              if (state.largeId != args.id) {
                setState((prev) => {
                  return {
                    ...prev,
                    type: 'large',
                    nextType: 'mid',
                    largeId: args.id,
                    largeName: args.name,
                    mid: [],
                    midId: '',
                    small: [],
                    smallId: '',
                    reload: new Date(),
                  };
                });
              }
            }}
          />
        </Col>
        <Col span={5}>
          <ExerciseCategory
            {...props}
            key={'mid'}
            title={'중분류'}
            parentId={state.largeId}
            categories={state.mid}
            selectedId={state.midId}
            initData={async () => {
              midInitData();
            }}
            addItem={async (args) => {
              // 추가
              // 부모가 선택되어야만 추가가능
              const { value, setChildState } = args;
              if (state?.largeId?.length && value.length) {
                await restApi.post(
                  `/admin/category?parentId=${state.largeId}`,
                  {
                    name: value,
                  }
                );
              }
              setChildState((prev) => {
                return {
                  ...prev,
                  loading: false,
                  reload: new Date(),
                };
              });
            }}
            updateItem={async (args) => {
              const { id, name } = args;
              if (id?.length && name.length) {
                await restApi.patch(`/admin/category/${id}`, {
                  name,
                });

                // 중분류 데이터 갱신 -> 소분류 까지 같이 가져오기 때문에
                midInitData();
              }
            }}
            deleteItem={async (args) => {
              const { id } = args;
              if (id?.length) {
                await restApi.delete(`/admin/category/${id}`);

                // 중분류 데이터 갱신 -> 소분류 까지 같이 가져오기 때문에
                midInitData();
              }
            }}
            OnCellClick={(args) => {
              if (state.midId != args.id) {
                setState((prev) => {
                  return {
                    ...prev,
                    type: 'mid',
                    nextType: 'small',
                    midId: args.id,
                    midName: args.name,
                    small: [],
                    smallId: '',
                    reload: new Date(),
                  };
                });
              }
            }}
          />
        </Col>
        <Col span={5}>
          <ExerciseCategory
            {...props}
            key={'small'}
            title={'소분류'}
            parentId={state.midId}
            categories={state?.small}
            selectedId={state?.smallId}
            initData={async () => {
              setLoading(true);

              (async () => {
                let i = state.mid.length;
                let small = [];
                for (let i = 0; i < state?.mid?.length; i++) {
                  const item = state.mid[i];
                  if (item.id == state.midId) {
                    small = [...item.subCategory];
                    break;
                  }
                }
                // --
                setState((prev) => {
                  return {
                    ...prev,
                    small: small,
                  };
                });
                setLoading(false);
              })();

              setTimeout(() => {
                setLoading(false);
              }, 2000);
            }}
            addItem={async (args) => {
              // 부모가 선택되어야만 추가가능
              // 추가
              const { value, setChildState } = args;
              if (state?.midId?.length && value.length) {
                await restApi.post(`/admin/category?parentId=${state.midId}`, {
                  name: value,
                });

                // 중분류 데이터 갱신 -> 소분류 까지 같이 가져오기 때문에
                midInitData();
              }
              setChildState((prev) => {
                return {
                  ...prev,
                  loading: false,
                  reload: new Date(),
                };
              });
            }}
            updateItem={async (args) => {
              const { id, name } = args;
              if (id?.length && name?.length) {
                await restApi.patch(`/admin/category/${id}`, {
                  name,
                });

                // 중분류 데이터 갱신 -> 소분류 까지 같이 가져오기 때문에
                midInitData();
              }
            }}
            deleteItem={async (args) => {
              const { id } = args;
              if (id?.length) {
                await restApi.delete(`/admin/category/${id}`);

                // 중분류 데이터 갱신 -> 소분류 까지 같이 가져오기 때문에
                midInitData();
              }
            }}
            OnCellClick={(args) => {
              if (state.smallId != args.id) {
                setState((prev) => {
                  return {
                    ...prev,
                    type: 'samll',
                    nextType: 'exercise',
                    smallId: args.id,
                    smallName: args.name,
                    reload: new Date(),
                  };
                });
              }
            }}
          />
        </Col>
        <Col span={9}>
          <ExerciseName
            {...props}
            parentId={state.reload}
            title={'새로운 운동명(영문명/국문명)'}
            big={state?.largeName}
            mid={state?.midName}
            sml={state?.smallName}
            categoryId={state?.smallId}
            messageApi={messageApi}
          />
        </Col>
      </Row>
      <div style={{ marginTop: 26 }} />
      {/* ---------------------------------------------------------------------------------------------------- */}
    </div>
  );
};

const styles = {
  constainer: {
    display: 'flex',
    width: '100%',
    // flex: 1,
    // height: '100%',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    width: '100%',
    height: '4.6rem',
    alignItems: 'center',
    padding: '0rem 1rem 0rem 1rem',
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
    borderRadius: '0.6rem',

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
    color: '#4B465C',
  },
};
export default CreateNewExercise;
